export const STATUS_META = {
  hot: { label: "Hot", color: "#EF4444", dot: "🔴", desc: "Likely to purchase soon" },
  warm: { label: "Warm", color: "#F97316", dot: "🟠", desc: "Interested, needs follow-up" },
  follow_later: { label: "Follow Later", color: "#EAB308", dot: "🟡", desc: "Interested, not immediate" },
  long_term: { label: "Long-Term", color: "#3B82F6", dot: "🔵", desc: "Future opportunity" },
  lost: { label: "Lost", color: "#71717A", dot: "⚫", desc: "No longer active" },
  completed: { label: "Completed", color: "#22C55E", dot: "🟢", desc: "Deal completed" },
};

export const STATUS_ORDER = ["hot", "warm", "follow_later", "long_term", "lost", "completed"];

export const SOURCES = ["WhatsApp", "Instagram", "Facebook", "LinkedIn", "Email", "Website", "Referral", "Other"];

export const CONTACT_TYPES = ["Customer", "Sub-Agent", "Team Member"];
